module.exports = __webpack_public_path__ + "img/icon_dean_home_alert_bg_2.3bd2e417.png";